import deviceType from "@/types/DeviceType";

export const DEVICE_TYPE_C01_0 = "C01.0";
export const DEVICE_TYPE_C01_0_ID = 1;
export const DEVICE_TYPE_C01_5 = "C01.5";
export const DEVICE_TYPE_C01_5_ID = 2;
export const DEVICE_TYPE_C01_5N = "C01.5N";
export const DEVICE_TYPE_C01_5N_ID = 3;
export const DEVICE_TYPE_C300 = "C300";
export const DEVICE_TYPE_C300_ID = 4;
export const DEVICE_TYPE_C500 = "C500";
export const DEVICE_TYPE_C500_ID = 5;
export const DEVICE_TYPE_FMC130 = "FMC130";
export const DEVICE_TYPE_FMC130_ID = 6;
export const DEVICE_TYPE_FTM887 = "FTM887";
export const DEVICE_TYPE_FTM887_ID = 7;

export const ALL_DEVICE_TYPE: deviceType[] = [
  {
    type: DEVICE_TYPE_C01_0,
    id: DEVICE_TYPE_C01_0_ID,
  },
  {
    type: DEVICE_TYPE_C01_5,
    id: DEVICE_TYPE_C01_5_ID,
  },
  {
    type: DEVICE_TYPE_C01_5N,
    id: DEVICE_TYPE_C01_5N_ID,
  },
  {
    type: DEVICE_TYPE_C300,
    id: DEVICE_TYPE_C300_ID,
  },
  {
    type: DEVICE_TYPE_C500,
    id: DEVICE_TYPE_C500_ID,
  },
  {
    type: DEVICE_TYPE_FMC130,
    id: DEVICE_TYPE_FMC130_ID,
  },
  {
    type: DEVICE_TYPE_FTM887,
    id: DEVICE_TYPE_FTM887_ID,
  },
];

export const DEVICE_TYPE: deviceType[] = [
  {
    type: DEVICE_TYPE_C01_0,
    id: DEVICE_TYPE_C01_0_ID,
  },
  {
    type: DEVICE_TYPE_C01_5,
    id: DEVICE_TYPE_C01_5_ID,
  },
  {
    type: DEVICE_TYPE_C01_5N,
    id: DEVICE_TYPE_C01_5N_ID,
  },
  {
    type: DEVICE_TYPE_C500,
    id: DEVICE_TYPE_C500_ID,
  },
];

export const TELTONIKA_DEVICE_TYPE: deviceType[] = [
  {
    type: DEVICE_TYPE_FMC130,
    id: DEVICE_TYPE_FMC130_ID,
  },
  {
    type: DEVICE_TYPE_FTM887,
    id: DEVICE_TYPE_FTM887_ID,
  },
];

export const visibleDeviceTypes = ALL_DEVICE_TYPE.filter((type) => {
  return type.id != 4;
});

export const TELTONIKA_DEVICE_TYPE_IDS = [
  DEVICE_TYPE_FMC130_ID,
  DEVICE_TYPE_FTM887_ID,
];

export const IMEI_REQUIRED_IDS = [
  DEVICE_TYPE_C500_ID,
  DEVICE_TYPE_FMC130_ID,
  DEVICE_TYPE_FTM887_ID,
];

export const DUCKS_MAKER_ID = 1;
export const HACIOBU_MAKER_ID = 2;
export const TELTONIKA_MAKER_ID = 3;
